let url_config = 'https://exhibition.zhongze.cc'


export {
	url_config
}